import Logo from "@assets/images/Logo-white.svg";
import { Link, useLocation, NavLink } from "react-router-dom";
import moment from "moment";
import config from "../../../config";

import "./footer.sass";
import { useTranslation } from "@helpers/translate";
import React, { useMemo } from "react";
import grayLogo from "@assets/images/logo/footer-gray-logo.png";
import { ReactComponent as XIcon } from "../../../assets/images/icons/x-icon.svg";
import { ReactComponent as GithubIcon } from "../../../assets/images/icons/github-icon.svg";
import { ReactComponent as InstagramIcon } from "../../../assets/images/icons/instagram-icon.svg";
import { ReactComponent as FacebookIcon } from "../../../assets/images/icons/facebook-icon.svg";

export const Footer = () => {
  const { __ } = useTranslation();
  const location = useLocation();

  const currentPath = location.pathname;

  const isAuthRoute = useMemo(
    () => currentPath.startsWith("/auth/"),
    [currentPath]
  );

  return (
    <div className={`${isAuthRoute ? "orange-footer" : ""}`}>
      <footer className={`footer ${isAuthRoute ? " footer--orange" : ""}`}>
        <div className="footer__gray-logo">
          <img src={grayLogo} alt="logo" />
        </div>

        <div className="footer__left">
          <Link to={"/"} className="footer__logo">
            <img src={Logo} alt="logo" />
          </Link>

          <div className="footer__socials">
            <Link to={"/"} className="footer__social-item">
              <XIcon width="19px" height="19px" />
            </Link>

            <Link to={"/"} className="footer__social-item">
              <GithubIcon width="19px" height="19px" />
            </Link>

            <Link to={"/"} className="footer__social-item">
              <InstagramIcon width="19px" height="19px" />
            </Link>

            <Link to={"/"} className="footer__social-item">
              <FacebookIcon width="19px" height="19px" />
            </Link>
          </div>
        </div>

        <div className="footer__right">
          <nav className="footer__nav">
            <ul className="footer__list">
              <li className="footer__item">
                <NavLink to="/" className="footer__link">
                  {__("common.trading")}
                </NavLink>
              </li>
              <li className="footer__item">
                <NavLink to="/markets" className="footer__link">
                  {__("common.markets")}
                </NavLink>
              </li>
              <li className="footer__item">
                <NavLink to="/wallet" className="footer__link">
                  {__("common.wallet")}
                </NavLink>
              </li>
              <li className="footer__item">
                <NavLink to="/profile" className="footer__link">
                  {__("common.profile")}
                </NavLink>
              </li>
              {/* <li className="footer__item">
                <NavLink to="/settings" className="footer__link">
                  {__("common.settings")}
                </NavLink>
              </li> */}
            </ul>
          </nav>

          <div className="footer__text-wrap">
            <p className="footer__text">
              {__("seo.title")} {moment().year()}. {__("main.footer.t1")}
            </p>
            <p className="footer__text">
              {__("main.footer.t2")}:{" "}
              <a href={`mailto:${config.infoEmail}`}>{config.infoEmail}</a>
            </p>
            {/*<p className="footer__text">
              {__("main.footer.t3")}:{" "}
              <a href={`mailto:${config.supportEmail}`}>{config.supportEmail}</a>
            </p>*/}
          </div>
        </div>
      </footer>
    </div>
  );
};
